<!-- @format -->

<template>
	<div v-show="visible" class="pc-contextmenu" :class="classes" :style="styles">
		<pc-menu v-if="visible" ref="menu" :items="data" />
	</div>
</template>

<script>
	import PcMenu from './menu';

	/**
	 * 点击菜单项时触发
	 * @event click
	 * @param {Object} item 菜单项数据
	 * @param {Object} vm 菜单项实例
	 */

	export default {
		name: 'PcContextmenu',
		components: {
			PcMenu,
		},
		provide() {
			return {
				wrapper: this,
			};
		},
		/**
		 * 属性参数
		 * @member props
		 * @property {string} [theme=light] 主题配色，可选 'light', 'dark'
		 * @property {Array} [data] 菜单项数据，[{icon, label, info, disabled, divider, children}]
		 * @property {string|object} [data.icon] 图标
		 * @property {string} [data.label] 标题文本
		 * @property {string} [data.info] 附加信息文本
		 * @property {boolean} [data.disabled] 禁用
		 * @property {boolean} [data.divider] 分割线
		 * @property {Array} [data.children] 子菜单项
		 * @property {boolean} [disabled] 禁用菜单
		 * @property {number} [zIndex=1000] 显示层级
		 * @property {String|HTMLElement|Function} 触发菜单容器，支持选择器和函数，默认 document.body
		 * @property {boolean} [manual] 手动模式，需要自行调用show 、hide 方法
		 */
		props: {
			// 主题风格
			theme: {
				type: String,
				default: 'light',
				validator(val) {
					return ['light', 'dark'].includes(val);
				},
			},
			// 数据 [{icon, label, info, disabled, divider, children}]
			data: {
				type: Array,
				default() {
					return [];
				},
			},
			disabled: Boolean,
			zIndex: {
				type: Number,
				default: 1000,
			},
			target: {
				type: [String, HTMLElement, Function],
				default() {
					return document.body;
				},
			},
			// 手动控制菜单显示
			manual: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				visible: false,
				flag: false,
				x: 0,
				y: 0,
				rect: null,
			};
		},
		computed: {
			styles() {
				return {
					left: `${this.x}px`,
					top: `${this.y}px`,
					zIndex: this.zIndex,
				};
			},
			classes() {
				return {
					[`is-${this.theme}`]: !!this.theme,
				};
			},
		},
		mounted() {
			this.triggerTarget = this.getTarget();
			document.body.appendChild(this.$el);
		},
		beforeUnmount() {
			if (this.$el && this.$el.parentNode) {
				this.$el.parentNode.removeChild(this.$el);
			}
			this.triggerTarget = null;
		},
		methods: {
			getTarget() {
				let el = document.body;
				if (typeof this.target === 'string') {
					el = document.querySelector(this.target);
				}
				if (typeof this.target === 'function') {
					el = this.target();
				}
				return el;
			},
			handleContextMenu(e, treeMenu) {
				if (this.disabled) return;
				e && e.preventDefault();
				if (treeMenu) {
					this.show({ x: e && e.pageX + 10, y: e && e.pageY + 10 });
				} else {
					this.show({ x: e && e.pageX, y: e && e.pageY });
				}

				return false;
			},
			getPlacement(rect, x, y) {
				const targetRect = this.triggerTarget.getBoundingClientRect();
				if (rect.height + y - Math.abs(targetRect.top) >= targetRect.height) {
					y -= rect.height;
				}
				if (rect.width + x - Math.abs(targetRect.left) >= targetRect.width) {
					x -= rect.width;
				}
				return {
					x,
					y,
				};
			},
			show({ x, y }) {
				this.visible = true;
				this.$nextTick(() => {
					const rect = this.$refs.menu.rect;
					if (!rect) {
						return;
					}
					const placement = this.getPlacement(rect, x, y);
					this.x = placement.x;
					this.y = placement.y;
				});
			},
			hide() {
				this.visible = false;
			},
		},
	};
</script>
